import { LegalClientTargetedFinancialInstrumentsEntity } from 'api/types/entity/legal/legalClientTargetedFinancialInstrumentsEntity';

import { TargetedFinancialInstrumentsFormType } from '../../forms/targetedFinancialInstrumentsForm';

const parseFinancialInstrument = (
  data: LegalClientTargetedFinancialInstrumentsEntity['financialInstruments']['bonds']
) => ({
  enabled: !!data,
  yearlyTradeAmount: data?.yearlyTradeAmount,
  monthlyTradeAmount: data?.monthlyTradeAmount ?? undefined,
});

export const parseTargetedFinancialInstrumentsValue = (
  targetedFinancialInstruments:
    | LegalClientTargetedFinancialInstrumentsEntity
    | undefined
) => {
  const values: TargetedFinancialInstrumentsFormType['targetedFinancialInstruments'] =
    {
      expectedMonthlyTradeQuantity:
        targetedFinancialInstruments?.operationsDetails
          .expectedMonthlyTradeQuantity,
      expectedYearlyTradeQuantity:
        targetedFinancialInstruments?.operationsDetails
          .expectedYearlyTradeQuantity,

      financialInstruments: {
        bonds: parseFinancialInstrument(
          targetedFinancialInstruments?.financialInstruments.bonds
        ),
        derivatives: parseFinancialInstrument(
          targetedFinancialInstruments?.financialInstruments.derivatives
        ),
        otherFinancialInstruments: parseFinancialInstrument(
          targetedFinancialInstruments?.financialInstruments
            .otherFinancialInstruments
        ),
        mutualFunds: parseFinancialInstrument(
          targetedFinancialInstruments?.financialInstruments.mutualFunds
        ),
        stocks: parseFinancialInstrument(
          targetedFinancialInstruments?.financialInstruments.stocks
        ),
        structuredProducts: parseFinancialInstrument(
          targetedFinancialInstruments?.financialInstruments.structuredProducts
        ),
      },
    };

  return values;
};
